import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcelModel } from 'src/app/hubadmin/shared/models/geography';
import { USER_PONITS_HEADER } from 'src/app/hubadmin/shared/models/mock-data';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';

@Component({
  selector: 'app-geo-group-add-edit',
  templateUrl: './geo-group-add-edit.component.html',
  styleUrls: ['./geo-group-add-edit.component.scss']
})
export class GeoGroupAddEditComponent implements OnInit {

  headerText:String;
  geoGroupName:String;
  geoGroupStatus;
  geogroup = {
    "id": 0,
    "status": 0,
    "created_date": null,
    "updated_date": null,
    "group_name": ""
}
  geoGroupId;
  geoUsers = [];
  tempOptionModel: any;
  excel: ExcelModel = new ExcelModel();
  constructor(
    private activate: ActivatedRoute,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    private route: Router,
    private modalService: NgbModal,
    public alertService: AlertService,
    public exportExcelService: ExportExcelService,
    private xlsx: XlsxService,
    private uploadFile: UploadZipService,
    
  ) {

    this.uploadFile.currentMessage.subscribe(message => {
      if(message.status == 'success'){
        this.ngOnInit();
      }
    })
   }

  ngOnInit() {
    this.activate.queryParams.subscribe(val=>{
      if(val.id == undefined){
        this.headerText = "Add";
      }else{
        this.headerText = "Edit";
        this.geoGroupId = val.id;
        this.getAllGeoGroup();
        this.getAllGeoUser();
      }
    })
  }

  getAllGeoGroup() {
    this.apiService.get(this.apiConfig.getGeoGroups+"?id="+this.geoGroupId)
      .subscribe((res: any) => {
        this.geogroup.id = res.data.id;
        this.geogroup.status = res.data.status;
        this.geogroup.group_name = res.data.group_name;
        this.geogroup.created_date = res.data.created_date;
        console.log(this.geogroup)
      }, err => {
        console.log(err);
      })
  }

  getAllGeoUser(){
    this.apiService.get(this.apiConfig.getGeoUser+"?geo_group_id="+this.geoGroupId)
      .subscribe((res: any) => {
        this.geoUsers = res.data;
        
        console.log(this.geoUsers)
      }, err => {
        console.log(err);
      })
  }

  updateData(data){
    this.apiService.put(this.apiConfig.updateGeoGroups+"?id="+this.geoGroupId, data)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Success("Updated Successfully");
        this.getAllGeoGroup();
      }
      else{
        this.toast.Warning(res.statusText);
      }
    }, err=>{
      console.log(err);
    })
  }
  createData(){
    let payload = {
      "group_name": this.geoGroupName
    }
    this.apiService.post(this.apiConfig.createGeoGroups, payload)
    .subscribe((res:any)=>{
      if(res.status == 201){
        this.toast.Success("Created Successfully");
        this.route.navigateByUrl("/hubAdmin/user-management/geo-group");
      }
      else{
        this.toast.Warning(res.statusText);
      }
    })
  }
  updateGeoUser(data){
   data.status = data.status == false ? 0 : 1;
   let payload = JSON.parse(JSON.stringify(data));
   delete payload.user_data;
   if(payload.status == false){
    payload.status = 0;
   }else{
    payload.status = 1;
   }
   this.apiService.put(this.apiConfig.updateGeoUser+"?id="+data.id, payload)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Success("Updated Successfully");
        this.getAllGeoUser();
      }
      else{
        this.toast.Warning(res.statusText);
      }
    }, err=>{
      console.log(err);
    })
   console.log(payload)
  }

  addUser(){
    this.route.navigateByUrl("/hubAdmin/user-management/geo-user");
  }


  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  downloadExcel() {
    this.exportExcelService.exportUserAssignment();
  }

  closeoptionModel() {
    this.tempOptionModel.close();
  }

  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }

  xlsxView(data) {
    data.apiHeaders = USER_PONITS_HEADER;
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.uploadMultiData(this.excel);
        }
      },
      (reason) => {}
    );
  }

  uploadMultiData(data) {
    data.excel_data.filter(i=>{
      i["rocode"] = i["Outlet Code"]
      delete i["Outlet Code"];
      delete  i.isEdit;
    })
    let payload = {
      "geo_group_id": this.geoGroupId,
      "users":data.excel_data
    }
    console.log(payload)
    this.enableUploadDiv(payload);
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.BulkLoadGeoUser,
      module: "User Assigment",
      zip: "no",
      excelname: "User Assignment Excel",
    });
  }
}
